{
  "title": "Freedom of Movement",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level abjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a leather strap, bound around the arm or a similar appendage)",
  "duration": "1 hour",
  "description": [
    "You touch a willing creature. For the duration, the target’s movement is unaffected by difficult terrain, and spells and other magical effects can neither reduce the target’s speed nor cause the target to be paralyzed or restrained.",
    "The target can also spend 5 feet of movement to automatically escape from nonmagical restraints, such as manacles or a creature that has it grappled. Finally, being underwater imposes no penalties on the target’s movement or attacks."
  ],
  "spellLists": ["artificer", "bard", "cleric", "druid", "ranger"]
}
